import isEqual from 'lodash/isEqual';

export const mapRange = (value, x1, y1, x2, y2) =>
  ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;

export const rotate = (degree, amount) => {
  const result = degree + amount;
  return result > 360 ? result - 360 : result;
};

export const coinFlip = () => Math.random() > 0.5;

// avoid this for circles, as it will have no visual effect
const zAxisRotation = [0, 0, 1];

export const rotationTransforms = [
  // dual axis rotations (a bit more realistic)
  [1, 1, 0],
  [1, 0, 1],
  [0, 1, 1],
  // single axis rotations (a bit dumber)
  [1, 0, 0],
  [0, 1, 0],
  zAxisRotation,
];

export const shouldBeCircle = (rotationIndex) => {
  return !isEqual(rotationTransforms[rotationIndex], zAxisRotation) && coinFlip();
};



// WEBPACK FOOTER //
// ./src/components/onboarding/utils.js